export const supportedLanguages = ['en', 'de'];
export const features = [
  'auth',
  'dashboard',
  'home',
  'customers',
  'users',
  'tenants',
  'revenue',
  'payoutHistory',
  'shared',
  'settings',
  'notifications'
];

const moduleConfig = {
  supportedLanguages,
  features,
};

export default moduleConfig;
